import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { HttpClient } from '@angular/common/http';
import { SpinnerService } from './spinner.service';
import { ToastService } from './toast.service';
import { Amenity } from '../models/amenity.model';
import { ITimetable, Timetable } from '../models/timetable.model';
import { environment } from '../../environments/environment';
import { IServerResponse, ServerResponse } from '../models/server-response.model';

@Injectable({
  providedIn: 'root'
})
export class ScheduleService {

  public loading: boolean = false;

  constructor(
    public authService: AuthService,
    private http: HttpClient,
    public spinnerService: SpinnerService,
    public toastService: ToastService
  ) { }

  /*
    ██████╗ ███████╗████████╗ █████╗ ██╗     ██╗
  ██╔════╝ ██╔════╝╚══██╔══╝██╔══██╗██║     ██║
  ██║  ███╗█████╗     ██║   ███████║██║     ██║
  ██║   ██║██╔══╝     ██║   ██╔══██║██║     ██║
  ╚██████╔╝███████╗   ██║   ██║  ██║███████╗███████╗
    ╚═════╝ ╚══════╝   ╚═╝   ╚═╝  ╚═╝╚══════╝╚══════╝

  */
  async getAll(
    amenity: Amenity,
    dateSelected: string
  ): Promise<Timetable[]> {

    this.loading = true;
    let timetables: Timetable[] = [];
  
    const urlApi = `${environment.urlApi}/neighborhoods/${amenity.neighborhoodId}/amenities/${amenity.amenityId}/schedules?date_selected=${dateSelected}`;
  
    try {
      const token = await this.authService.getToken();
  
      const response = await new Promise<ServerResponse<{ timetables: ITimetable[] }>>(
        (resolve, reject) => {
          this.http.get<IServerResponse<{ timetables: ITimetable[] }>>(
            urlApi,
            {
              headers: {
                "content-type": "application/json",
                "Authorization": token.toString()
              }
            }
          ).subscribe({
            next: (
              response: IServerResponse<{ timetables: ITimetable[] }>
            ) => resolve(
              new ServerResponse<{ timetables: ITimetable[] }>(response)
            ),
            error: (error) => {
              if (error.error) {
                resolve(new ServerResponse(error.error));
              } else {
                reject(error);
                this.toastService.show(
                  {
                    header: 'Error de servidor',
                    body: `${error}`,
                    classname: 'bg-danger text-white'
                  }
                );
              }
            }
          });
        }
      );

      console.log(response);
      
  
      if (response.statusCode === 200) {
        timetables = response.data!.timetables.map(
          (timetable) => new Timetable(timetable)
        );
      } else {
        this.toastService.show(
          {
            header: 'Error de servidor',
            body: `${response.message}`,
            classname: 'bg-danger text-white'
          }
        );
      }
  
    } catch (error) {
      console.log(error);
      this.toastService.show(
        {
          header: 'Error',
          body: `${error}`,
          classname: 'bg-danger text-white'
        }
      );
    }
  
    this.loading = false;

    return timetables;
  }
}
